import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import AppRoutes from "./routes/AppRoutes";

function getDeviceType() {
  const userAgent = navigator.userAgent;
  const width = window.innerWidth;
  if (/Mobi|Android/i.test(userAgent) || width <= 768) {
    return "Mobile";
  } else if (/Tablet|iPad/i.test(userAgent) || (width > 768 && width <= 1024)) {
    return "Tablet";
  } else {
    return "Desktop";
  }
}
function App() {
  const [isPortrait, setIsPortrait] = useState(false);
  const [deviceType, setDeviceType] = useState("Other");

  useEffect(() => {
    const detectedDevice = getDeviceType();
    setDeviceType(detectedDevice);

    if (detectedDevice === "Tablet") {
      const checkOrientation = () => {
        setIsPortrait(window.matchMedia("(orientation: portrait)").matches);
      };

      checkOrientation();
      window.addEventListener("resize", checkOrientation);
      window.addEventListener("orientationchange", checkOrientation);

      return () => {
        window.removeEventListener("resize", checkOrientation);
        window.removeEventListener("orientationchange", checkOrientation);
      };
    }
  }, []);
  return (
    <>
      {deviceType === "Tablet" && isPortrait && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "primary.main",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            color: "white",
          }}
        >
          <Typography
            variant="h3"
            align="center"
            sx={{ mb: 2, fontWeight: "bold" }}
          >
            Please Rotate Your Device
          </Typography>
          <Typography variant="h6" align="center" sx={{ opacity: 0.9 }}>
            For the best experience, please use landscape orientation
          </Typography>
        </Box>
      )}

      <AppRoutes />
    </>
  );
}

export default App;
